import { PageType } from "shared/lib/page-type";

export const pathname = "/topic";

export const page = {
  route(query: QueryParameters<{ entityId: string }>) {
    return {
      pathname,
      query: { ...query, pageType: PageType.Topic },
    };
  },
};
